module.exports = __webpack_public_path__ + "static/media/shtrips1.15577d06.jpg";